;(function () {
  'use strict';

  /**
   * ReportItemProfileImage設定モーダル
   */
  var itemProfileImageConfig = {
    initDialog: function (options) {
      var dialogClass = '.js-item-profile-image-dialog[data-item-id="' + options['itemId'] + '"]';
      var openButton = '.add-item-profile-image[data-item-id="' + options['itemId'] + '"]';
      var closeButton = '.js-dialog--profile__close';

      var config = $.extend({
        dialog: dialogClass, // ダイアログのセレクタ
        sideMargin: 15, // 左右の余白 [px]
        openButton: openButton,
        closeButton: closeButton
      }, options);

      if ($('body.sp-viewport').length) {
        // sp版モーダル設定
        $(config.dialog).dialog({
          autoOpen: false,
          draggable: false,
          resizable: false,
          modal: true,
          width: $(window).width() - (config.sideMargin * 2),
          position: {
            my: 'center',
            at: 'center',
            of: window
          },
          dialogClass: 'dialog-profile',
          show: 'fast',
          hide: 'fast'
        });
      } else {
        // pc版モーダル設定
        $(config.dialog).dialog({
          autoOpen: false,
          draggable: false,
          resizable: false,
          modal: true,
          width: 800,
          position: {
            my: 'center',
            at: 'center',
            of: window
          },
          dialogClass: 'dialog-profile',
          show: 'fast',
          hide: 'fast'
        });
      }

      /**
       * モーダル 表示イベント
       */
      $(config.openButton).on('click', function () {
        $(config.dialog).dialog('open');
        return false;
      });

      /**
       * モーダル 非表示イベント
       */
      $(config.closeButton).on('click', function () {
        $(config.dialog).dialog('close');
        return false;
      });
    },

    initCropper: function (options) {
      var dialogClass = '.js-item-profile-image-dialog[data-item-id="' + options['itemId'] + '"]';
      var openButton = '.add-item-profile-image[data-item-id="' + options['itemId'] + '"]';

      var $dialog = $(dialogClass);
      $dialog.dialog('open');

      var $progress = $dialog.find('.progress .bar');
      var $preview = $dialog.find('.temporary-image-preview > img');
      var $message = $dialog.find('.message > p');
      var $submit = $dialog.find('button.submit');
      var $imageTag = $dialog.find('.temporary-image');
      // Cropperを起動した時はsubmitボタンを隠す
      $submit.hide();
      // Cropper の初期化が完了したら submit ボタンを有効にする。
      $preview.on('built.cropper', function () {
        $message.html('範囲を選択して登録してください。');
        $submit.show();
      });

      // ファイルアップロード
      $dialog.find('input[type="file"].upload').fileupload({
        dataType: 'json',
        send: function (e, date) {
          $submit.hide();
          $preview.cropper('destroy');
          $message.html('画像をアップロードしています。');
          $progress.css('width', '0%');
          $progress.show();
        },
        done: function (e, data) {
          $progress.hide();
          $.each(data.result.files, function (index, file) {
            if (file.error) {
              $message.html(file.error);
            } else {
              // jQuery の data 属性の キャシュ 対策 のため setAttribute を用いる。
              // https://w3g.jp/blog/jquery-data-attr-cache
              $imageTag[0].setAttribute('src', file.url);
              $imageTag[0].setAttribute('data-filename', file.name);
              var aspect_rate = $preview.data('aspect-rate');
              $preview.cropper({autoCropArea: 1.0, aspectRatio: aspect_rate, zoomable: false, viewMode: 0, minCropBoxWidth: 32, minCropBoxHeight: 32});
            }
          });
        },
        progressall: function (e, data) {
          var progress = parseInt(data.loaded / data.total * 100, 10);
          $progress.css('width', progress + '%');
        }
      });

      // 登録ボタン
      $submit.on('click', function () {
        var canvasData = $preview.cropper('getCanvasData');
        var cropBoxData = $preview.cropper('getCropBoxData');
        // jQuery の data 属性の キャシュ 対策 のため getAttribute を用いる。
        var filename = $imageTag[0].getAttribute('data-filename');

        var formData = new FormData();
        formData.append('temporary_image[canvas]', JSON.stringify(canvasData));
        formData.append('temporary_image[cropped]', JSON.stringify(cropBoxData));
        formData.append('temporary_image[filename]', filename);

        $.ajax('/temporary_images/' + filename + '/trim', {
          type: 'post',
          processData: false,
          contentType: false,
          data: formData,
          dataType: 'json',
          beforeSend: function () {
            $submit.prop('disabled', true);
          },
          success: function (data) {
            $preview.cropper('destroy');
            $submit.hide();
            var addImageBtn = $(openButton);
            addImageBtn.html('<img src="' + data.files[0].url + '" width="75" height="75">');
            var fileForm = '<input type="hidden" name="report_item[profile][' + options['itemId'] + '][image]" value="' + data.files[0].name + '">';
            addImageBtn.append(fileForm);
            $dialog.dialog('close');
            $('.placeholder[data-item-id="' + options['itemId'] + '"]').hide();

            var $targetElement = $('.js-report-get-master-image[data-item-id=' + options['itemId'] + ']');
            // フォーム内 削除ボタン 削除
            $targetElement.find('.js-delete-item-profile-image-btn').remove();
          },
          error: function (data) {
            $message.html(data.message);
          }
        });
      });
    }
  };

  $(function () {
    $(document).on('click', '.add-item-profile-image', function () {
      var itemId = $(this).data('item-id');
      itemProfileImageConfig.initDialog({'itemId': itemId});
      itemProfileImageConfig.initCropper({'itemId': itemId});
    });
  });
}.call(this));
